<template>
  <div class="chart"></div>
</template>

<style lang="scss">

$ct-line-width: 2px;
$ct-grid-color: #c8c8c8;
$ct-grid-dasharray: none;
$ct-series-colors: (
  #19bfff,
  #57e607,
  #f05b4f,
  #f4c63d,
  #d17905,
  #453d3f,
  #0544d3,
  #6b0392,
  #f05b4f,
  #dda458,
  #eacf7d,
  #86797d,
  #b2c326,
  #6188e2,
  #a748ca
) !default;

@import "~chartist/dist/scss/chartist";

.chart {
  position: relative;
  background: #646464;
}
</style>

<script>
import { mapGetters } from 'vuex'
import Chartist from 'chartist'

export default {
  computed: {
    ...mapGetters({
      series: 'chartSeries'
    })
  },

  watch: {
    series () {
      this.chart = new Chartist.Line(this.$el, {
        series: [
          this.series.speed,
          this.series.elevation
        ]
      }, {
        showPoint: false,
        showLine: true,
        showArea: false,
        fullWidth: true,
        showLabel: false,
        axisX: {
          showGrid: true,
          labelInterpolationFnc: (v, i) => {
            return i % 60 === 0 ? i : null
          },
          showLabel: true,
          offset: 0
        },
        axisY: {
          showGrid: false,
          showLabel: false,
          offset: 0
        },
        chartPadding: { left: 0, right: 0, top: 5, bottom: 5 },
        low: 0
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Chart.vue?d3650d4c